<template>
  <el-dialog
    v-model="dialogStatus"
    :close-on-click-modal="false"
    @close="close"
    :title="dialogTitle"
    :width="width"
    append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item prop="dspId">
        <template v-slot:label>
          所属广告主
        </template>
        <search-dsp-select
          v-model="form.dspId"
          :dspType="2"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item prop="linkPlatform">
        <template v-slot:label>
          平台
        </template>
        <div style="display: inline-block; width: 100%">
          <el-radio
            v-for="item in linkTypeList"
            v-model="form.linkPlatform"
            :label="item.value"
            :key="item.value">{{ item.label }}
          </el-radio>
        </div>
      </el-form-item>

      <el-form-item label="名称" prop="linkName">
        <el-input
          v-model="form.linkName"

          type="textarea"
          autosize
          placeholder="请输入名称"
        />
      </el-form-item>

      <el-form-item label="渠道号" prop="linkChannel">
        <el-input
          v-model="form.linkChannel"

          type="textarea"
          autosize
          placeholder="请输入渠道号"
        />
      </el-form-item>

      <el-form-item label="投放链接" prop="linkUrl">
        <el-input
          v-model="form.linkUrl"

          type="textarea"
          autosize
          placeholder="请输入投放链接"
        />
      </el-form-item>

      <el-form-item label="唤起链接" prop="deeplink">
        <el-input
          v-model="form.deeplink"

          type="textarea"
          autosize
          placeholder="请输入唤起链接"
        />
      </el-form-item>

      <el-form-item label="上报链接" prop="reportUrl">
        <el-input
          v-model="form.reportUrl"

          type="textarea"
          autosize
          placeholder="请输入上报链接"
        />
      </el-form-item>

      <el-form-item label="扩展参数" prop="linkExt">
        <el-input
          v-model="form.linkExt"

          type="textarea"
          autosize
          placeholder="请输入参数"
        />
      </el-form-item>

      <el-form-item label="备注" prop="linkRemark">
        <el-input
          v-model="form.linkRemark"

          type="textarea"
          autosize
          placeholder="请输入备注"
        />
      </el-form-item>

    </el-form>
    <div style="text-align: right;">
      <el-button @click="close" >取消</el-button>
      <el-button @click="submit" type="primary"  :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {addLink, updateLink} from '@/api/manage/link/link'
import SearchDspSelect from '@/components/SearchDspSelect'
import {linkTypeList} from "@/const/link-type";

const form = {
  dspName: undefined,
  dspId: undefined,
  linkPlatform: undefined,
  linkName: undefined,
  linkChannel: undefined,
  linkUrl: undefined,
  deeplink: undefined,
  linkRemark: undefined,
  linkExt: undefined,
  createTime: undefined,
  updateTime: undefined,
}
export default {
  props: {
    title: String,
    width: {
      type: Number,
      default: 800
    },
    data: Object
  },
  emits: ['submit'],
  components: {
    SearchDspSelect
  },
  data() {
    return {
      dialogStatus: false,
      submitLoading: false,
      form: Object.assign({}, form),
      rules: {
        dspId: [{required: true, message: '请输入DSP简称', trigger: 'blur'}],
        linkPlatform: [{required: true, message: '请选择平台', trigger: 'blur'}],
        linkName: [{required: true, message: '请输入名称', trigger: 'blur'}],
        linkUrl: [{required: true, message: '请输入投放链接', trigger: 'blur'}]
      },
      budgetList: [],
      linkTypeList: linkTypeList
    }
  },
  computed: {
    dialogTitle() {
      return (this.title ? this.title : '') + (this.form.linkId ? '编辑' : '新增')
    }
  },
  created() {
  },
  methods: {
    show(data) {
      this.dialogStatus = true
      if (data) {
        this.form = Object.assign({}, data)
      }
    },
    close() {
      this.dialogStatus = false
      this.reset()
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.linkId) {
            this.updateLink(this.form)
          } else {
            this.addLink(this.form)
          }
        }
      })
    },
    addLink(form) {
      this.submitLoading = true
      addLink(form).then(res => {
        if (res.code === 200) {
          this.$message.success('新增成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    updateLink(form) {
      this.submitLoading = true
      updateLink(form).then(res => {
        if (res.code === 200) {
          this.$message.success('编辑成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    reset() {
      this.form = Object.assign({}, form)
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 15px;
}
</style>
